import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { DateWrapper } from './dateBubble.styles';
import { getRelativeFormattedDate } from './dateBubble.utils';

type Props = {
  bgColor?: ThemeColorType;
  date: Date;
  usTimeFormat?: boolean;
};

export const DateBubble = ({ date, bgColor, usTimeFormat }: Props) => (
  <DateWrapper bgColor={bgColor}>{getRelativeFormattedDate(date, usTimeFormat)}</DateWrapper>
);
